const languages = {
    langs: {
        english : {
            label: 'English',
            langCode : 'en-US',
        },
        german : {
            label: 'German',
            langCode : 'de-DE',
        },
        russian : {
            label: 'Russian',
            langCode : 'ru-RU',
        },
        french : {
            label: 'French',
            langCode : 'fr-FR',
        },
        azeri : {
            label: 'Azeri',
            langCode : 'az-AZ',
        },
        italian : {
            label: 'Italian',
            langCode : 'it-IT',
        },
        spanish : {
            label: 'Spanish',
            langCode : 'es-ES',
        },
    }
}

export default languages;


// WEBPACK FOOTER //
// ./src/config/laguages.js